module.exports = __webpack_public_path__ + "static/media/referalLink.bfd43885.svg";